import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Popup, Button, EnvContext } from 'next-common-lib';
import i18n from 'i18n';
import { WIZARD_STEP } from 'constants/wizardConstants';
import { getLanguage } from 'utils/cookies';
import Alert from 'components/Common/Popup/Alert';
import SetupPopup from 'components/SetupPage/SetupPopup';
import * as wizardActions from 'redux/ducks/common/wizardDuck';
import * as adminActions from 'redux/ducks/adminInfo/adminInfoDucks';
import * as boardActions from 'redux/ducks/Board/BoardDucks';
import * as anniversaryActions from 'redux/ducks/Anniversary/AnniversaryDucks';

// 위자드 메인

export const WizardMain = () => {
  const [step, setStep] = useState(WIZARD_STEP.START);
  const isShow = useSelector(state => state.wizard.isShow);
  const admin = useSelector(state => state.adminInfo);
  const board = useSelector(state => state.board);
  const dispatch = useDispatch();
  const { setEnvLanguage } = useContext(EnvContext);

  useEffect(() => {
    dispatch(adminActions.getAdminInfo());
  }, []);

  useEffect(() => {
    if (admin.adminVo) {
      dispatch(boardActions.addBoardList()); // 회사게시판 메뉴가 생성을 위해 최초 1회 호출 필수 api
      const payload = {
        subject: 'default',
        type: 'COMPANNIVERSARY',
        timezone: 'Asia/Seoul',
        regType: 'ADMIN',
        color: '#fe9b7c',
        publicTargets: [
          {
            authority: 'VIEW_SCHEDULE',
            target: 'COMPANY',
            targetId: admin.adminVo.compCd,
          },
        ],
      };
      dispatch(anniversaryActions.createAnniversaryComp(payload)); // pims 기념일 관리 내 회사 등록을 위한 최초 1회 필수 api
      const approvalPaylod = {
        apConfId: 'auto',
        compCd: admin.adminVo.compCd,
        keepTermVal: '4015', // 회사 joinClsfCd로 보존기간 변경
        ttAplnNum: '99',
        ttAprNum: '0',
        ttCstrNum: '0',
        ttNtfrNum: '0',
        prlOnlUseYn: '0',
        fnlApUseYn: '0',
        charDlvryTypeCd: '0',
        ntfMlTypeCd: '0',
        apOrgTypeCd: 'C',
      };
      dispatch(adminActions.createApprovalComp(approvalPaylod));
      const language = getLanguage();
      setEnvLanguage(language, true, { initLanguage: language });
    }
  }, [admin.adminVo]);

  useEffect(() => {
    if (board.addBoard) {
      dispatch(
        boardActions.getTopMenuList({
          compCd: admin.adminVo.compCd,
          suborgCd: admin.adminVo.compCd,
          dfltTopMenuYn: 'ALL',
          useYn: 'ALL',
        }),
      );
    }
  }, [board.addBoard]);
  useEffect(() => {
    if (admin.config) {
      setStep(WIZARD_STEP.SETUP_JOBTITLE);
      dispatch(wizardActions.close());
      dispatch(wizardActions.startSetup());
    }
  }, [admin.config]);

  return (
    <>
      {step === WIZARD_STEP.START ? (
        <Popup
          isDimed
          isShow={isShow}
          className="step-wizard"
          dimedClassName="has-bg"
          id="popup1"
          size="lg wizard"
          componentType="normalPopup"
          contentsComponent={[
            <div className="center-wrap">
              <div className="title-wrap">
                <div className="larger-title">
                  {i18n.t('BTY_W_T_WELCOME')}
                  &nbsp;
                </div>
                <h1 className="larger-title">
                  {admin.adminVo && navigator.language.substring(0, 2) === 'ko'
                    ? admin.adminVo.fnm
                    : admin.adminVo?.enFnm}
                </h1>
                <p className="larger-title">{i18n.t('BTY_W_T_WELCOME_P')}</p>
              </div>
              <h1 className="page-title">{i18n.t('BTY_W_T_WELCOME_DETAIL')}</h1>
              <div className="grid-box-wrap">
                <div className="grid-box">
                  <div className="wizard_main" />
                </div>
              </div>
              <Button
                componentType="solid"
                className="btn-start"
                size="lg"
                label={i18n.t('BTY_W_T_START')}
                onClick={() => {
                  dispatch(adminActions.updatePortalConfig({ ptConfYn: 'Y' }));
                  setStep(WIZARD_STEP.SETUP_JOBTITLE);
                  dispatch(wizardActions.close());
                  dispatch(wizardActions.startSetup());
                }}
              />
              <p className="sub-text">{i18n.t('BTY_W_T_NOTICE_BRWSER')}</p>
            </div>,
          ]}
          closeFunction={false}
          useScroll={false}
        />
      ) : (
        <SetupPopup setStep={setStep} step={step} />
      )}
      <Alert />
    </>
  );
};

WizardMain.propTypes = {};
WizardMain.defaultProps = {};

export default WizardMain;
